import { __awaiter, __generator } from "tslib";
import { getSiteSettingsApiConfig } from './config/actions';
import { fetchSiteSetting } from './http/fetch-site-setting';
/** Fetches `ecom` setting from site settings. Always return `false` if external content is loaded. */
export var fetchEcomSetting = function () { return __awaiter(void 0, void 0, void 0, function () {
    var isExternalContent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isExternalContent = getSiteSettingsApiConfig().isExternalContent;
                if (isExternalContent) {
                    return [2 /*return*/, Promise.resolve({ ecomEnabled: false })];
                }
                return [4 /*yield*/, fetchSiteSetting("ecom" /* Ecom */)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
